import PropTypes from "prop-types"
import React from "react"
import "./Button.scss"

const Button = props =>
  props.type === "button" ? (
    <button
      id={props.id}
      type="button"
      className={props.classname}
      disabled={props.isEnabled}
      onClick={props.onClickAction}
    >
      {props.text}
    </button>
  ) : (
    <input
      className={props.classname}
      type="submit"
      value={props.text}
      disabled={props.isEnabled}
    />
  )

Button.propTypes = {
  type: PropTypes.string.isRequired,
  classname: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClickAction: PropTypes.func,
  isEnabled: PropTypes.bool,
}

export default Button
